module.exports = __webpack_public_path__ + "static/media/14.e74b4e5c.JPG";